export default __webpack_public_path__ + "static/raheja-b8709e9d3ed40dff6a0147128273cafa.png";